/* eslint-disable angular/factory-name */

angular.
module("digiexam.services.faults").
factory("faults", function faultsService() {
	"use strict";

	// MIGRATION: There's a copy of Faults in the Angular app so if a field is added, add in both places
	return {
		NONE: 0,
		UNSPECIFIED: 1,
		CONTACT_SUPPORT: 2,
		ALREADY_SIGNED_UP: 3,
		PASSWORDS_DO_NOT_MATCH: 4,
		INVALID_CREDENTIALS: 5,
		BLANK_REQUIRED_FIELDS: 6,
		WRONG_VERIFICATION_CODE: 7,
		PAGE_NOT_FOUND: 8,
		MAX_UPLOAD_SIZE_EXCEEDED: 9,
		STORAGE_LIMIT_EXCEEDED: 10,
		FACEBOOK_LOGIN_FAILURE: 11,
		USERNAME_ALREADY_EXIST: 12,
		USERNAME_NOT_ALLOWED: 13,
		EMAIL_ADDRESS_NOT_VALID: 14,
		NAME_NOT_ALLOWED: 15,
		INSUFFICIENT_RIGHTS: 16,
		UNSUPPORTED_FILE_TYPE: 17,
		PASSWORD_TOO_SHORT: 18,
		PASSWORD_TOO_LONG: 19,
		USER_NOT_FOUND: 20,
		EXAM_NOT_OPEN: 21,
		EXAM_HAS_ENDED: 22,
		STUDENT_ID_NOT_REGISTERED: 23,
		EXAM_ALREADY_DOWNLOADED: 24,
		EXAM_START_TIME_ELAPSED: 25,
		CLASS_ALREADY_ADDED: 26,
		INVALID_REGISTRATION_CODE: 27,
		STUDENT_ALREADY_ADDED: 28,
		REGISTRATION_CLOSED: 29,
		EMAIL_NOT_VERIFIED: 30,
		ENTITY_NOT_FOUND: 31,
		STUDENT_NOT_BELONG_TO_USER:	32,
		UNAUTHORIZED: 33,
		FORBIDDEN: 34,
		EXAM_ACTIVE: 35,
		EXAM_NOT_GRADED: 36,
		EXAM_GRADED: 37,
		EXAM_PUBLISHED: 38,
		EMAIL_ALREADY_VERIFIED: 39,
		EXAM_NOT_FOUND: 40,
		MODEL_VALIDATION_ERRROR: 41,
		USER_DISABLED: 42,
		INVITE_CLAIMED: 43,
		INVITE_INCORRECT_TOKEN: 44,
		TOKEN_EXPIRED: 45,
		TOKEN_ALREADY_USED: 46,
		TOO_MANY_REQUESTS: 47,
		USER_WRONG_REGION: 48,
		TERMS_NOT_ACCEPTED: 49,
		CLIENT_DEPRECATED: 50,
		PASSWORD_HAS_WHITESPACE: 51,
		PASSWORD_COMMON: 52,
		STUDENT_NOT_ACTIVATED: 53, // DEPRECATED
	};
});
